"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
var __1 = require("../../..");
var context_1 = require("../../../../context");
var enums_1 = require("../../../../types/enums");
var utils_1 = require("../../../../utils");
var Card_1 = require("../../../Card");
var FormControl_1 = __importDefault(require("../../../FormControl"));
var Input_1 = __importDefault(require("../../../Input"));
var Select_1 = __importDefault(require("../../../Select"));
var Tabs_1 = require("../../../Tabs/Tabs");
exports.errorKeys = [
    'heating_type',
    'heating_system_model',
    'heating_system_working',
    'heating_system_working_other',
    'heating_controls',
    'heating_controls_other',
    'boiler_photo_1',
    'boiler_photo_2',
    'boiler_photo_3',
    'boiler_photo_4',
    'boiler_photo_5',
    'boiler_photo_6',
];
var HeatingSystemForm = function (_a) {
    var tabId = _a.tabId;
    var _b, _c;
    var trans = context_1.useSemantics().trans;
    var setTabError = Tabs_1.useTabsContext().setTabError;
    var _d = formik_1.useFormikContext(), errors = _d.errors, values = _d.values;
    var _e = react_1.useState(((_b = errors.project) === null || _b === void 0 ? void 0 : _b.heating) || {}), formErrors = _e[0], setFormErrors = _e[1];
    react_1.useEffect(function () { return setTabError(tabId, utils_1.objectHasAnyKey(formErrors, exports.errorKeys)); }, [formErrors]);
    react_1.useEffect(function () { var _a; return setFormErrors(((_a = errors.project) === null || _a === void 0 ? void 0 : _a.heating) || {}); }, [(_c = errors.project) === null || _c === void 0 ? void 0 : _c.heating]);
    return (react_1.default.createElement(Card_1.Card, { heading: trans('project:slhh::headings.heating-system'), subHeading: trans('project:slhh::headings.details') },
        react_1.default.createElement(FormControl_1.default, { errors: formErrors.heating_type, label: trans('project:slhh::labels.heating-type') },
            react_1.default.createElement(Select_1.default, { width: "xs", options: {
                    combi_non_condensing: 'Combi non-condensing',
                    non_condensing: 'Non-condensing',
                    combi_condensing: 'Combi-condensing',
                    condensing: 'Condensing',
                    back_boiler: 'Back-boiler',
                    electric_storage: 'Electric-storage',
                    electric_panel: 'Electric-panel',
                    electric_portable: 'Electric-portable',
                    warm_air: 'Warm air',
                    gas_room: 'Gas room',
                }, name: "project.heating.heating_type" })),
        react_1.default.createElement(FormControl_1.default, { errors: formErrors.heating_system_model, label: trans('project:slhh::labels.heating-system-model') },
            react_1.default.createElement(Input_1.default, { name: "project.heating.heating_system_model", maxLength: 255 })),
        react_1.default.createElement(FormControl_1.default, { errors: formErrors.heating_system_working, label: trans('project:slhh::labels.heating-system-working'), showOther: values.project.heating.heating_system_working === enums_1.BooleanOther.OTHER, other: react_1.default.createElement(FormControl_1.default, { errors: formErrors.heating_system_working_other, label: trans('project:slhh::labels.heating-system-working-other') },
                react_1.default.createElement(__1.TextArea, { fast: true, name: "project.heating.heating_system_working_other", maxLength: 5000 })) },
            react_1.default.createElement(Select_1.default, { width: "xs", options: {
                    yes: 'Yes',
                    no: 'No',
                    intermittently: 'Intermittently',
                    other: 'Other',
                }, name: "project.heating.heating_system_working" })),
        react_1.default.createElement(FormControl_1.default, { errors: formErrors.heating_controls, label: trans('project:slhh::labels.heating-controls'), flush: true },
            react_1.default.createElement(Select_1.default, { width: "xs", options: {
                    programmer: 'Programmer',
                    trvs: 'TRVs',
                    thermostat: 'Thermostat',
                    appliance_thermostat: 'Appliance Thermostat',
                    other: 'Other',
                }, name: "project.heating.heating_controls" }))));
};
exports.default = HeatingSystemForm;
//# sourceMappingURL=HeatingSystemForm.js.map